// extracted by mini-css-extract-plugin
export default {"overlay":"Vx-z","bodyOpen":"Wx-z","content":"Xx-z","header":"Yx-z","close":"Zx-z","closeNoHeading":"_x-z"};